import React from 'react';

interface TimeInputProps {
  value: string;
  onClick: () => void;
  placeholder?: string;
  className?: string;
}

const TimeInput = React.forwardRef<HTMLInputElement, TimeInputProps>(
  function TimeInput({ value, onClick, placeholder, className }, ref) {
    return (
      <div className="input-group">
        <input
          ref={ref}
          className={`form-control ${className ?? ''}`}
          value={value}
          readOnly // picker 前提なので編集不可
          placeholder={placeholder}
          onClick={onClick} // Enter/Space 対応も入れるなら onKeyDown を追加
        />
      </div>
    );
  }
);

export default TimeInput;
